import { createContext, useContext } from "react";
const CoursePreviewContext = createContext(null);
const useCoursePreviewContext = ()=>{
    const context = useContext(CoursePreviewContext);
    if (!context) throw new Error('useCoursePreviewContext must be used within a CoursePreviewProvider');
    return context;
};
export { CoursePreviewContext, useCoursePreviewContext };
